export default "__VITE_ASSET__C294hJo3__"